// extracted by mini-css-extract-plugin
export var disabled = "styles-module--disabled--69673";
export var dollarSign = "styles-module--dollarSign--1aa73";
export var label = "styles-module--label--bb89e";
export var noMargin = "styles-module--noMargin--accb1";
export var numberInput = "styles-module--numberInput--855b6";
export var percentageSign = "styles-module--percentageSign--ddc82";
export var wrapper = "styles-module--wrapper--c3e46";